import { useQuery } from "@tanstack/react-query";
import { ScenarioDiff } from "@/model";
import deployRepository from "@/repository/deployRepository";


export const useScenarioDeployDiff = (scenarioId: string, deployId: string) => {
    return useQuery<ScenarioDiff>({
        queryKey: ['scenario-deploy-diff', scenarioId, deployId],
        queryFn: async () => {
            const response = await deployRepository.getDiff(scenarioId, deployId);
            return response.data?.diff;
        },
        enabled: !!scenarioId && !!deployId
    });
};
